export const DEVICES = {
  MOBILE: "mobile",
  DESKTOP: "desktop"
};
export const URL = {
  OAUTH_QA: "http://qa.accounts-internal-stg-cloud.paytm.com",
  STAG: "https://accounts-staging.paytm.in",
  PROD: "https://accounts.paytm.com",
  ITE: "https://oauth-qa.paytm.in",
  UAT: "https://accounts-uat.paytm.com",
  DEV: "http://dev.accounts-internal-stg-cloud.paytm.com",
  LOCAL: "http://localhost"
};
export function getCurrentEnv() {
  const host = document && document.location && document.location.host;
  switch (host) {
    case "accounts.paytm.com":
      return URL.PROD;
    case "accounts-staging.paytm.in":
      return URL.STAG;
    case "qa.accounts-internal-stg-cloud.paytm.com":
      return URL.OAUTH_QA;
    case "oauth-qa.paytm.in":
      return URL.ITE;
    case "accounts-uat.paytm.com":
      return URL.UAT;
    case "dev.accounts-internal-stg-cloud.paytm.com":
      return URL.DEV
    default:
      return URL.LOCAL
  }
}
export const defaultConfig = {
  "redirectPaytmDeepLink": "https://m.paytm.me/login_mob",
  "iosPasswordRule": "minlength: 8; maxlength: 12; required: lower; required: upper; required: digit; required: [{},/@$#+:.\";_-+];",
  "logoutConsentChecked": false,
  "fraud_detection_ivr_number": "1800120130",
  "otpFreezeConsent": false,
  "forget_password_ivr_number": "1800120130",
  "userLogoutConsent": "LOGOUT_FROM_ALL_DEVICES",
  "sdk_config": "{\"login\":{\"email\":true,\"mobile\":false,\"QR\":{\"primary\":false},\"description\":\"\"},\"signup\":{\"email\":{\"required\":false},\"confirmPass\":true,\"consent\":{\"title\":\"I hearby confirm that I am above 18 years old.\"},\"description\":\"\"},\"forgetPassword\":{\"emailReset\":true}}",
  "country_name_country_code_map": "Singapore=65,Hong Kong=852,Cyprus=357,Portugal=351,Oman=968,Russia=7,Malta=356,Saudi Arabia=966,Greece=30,Austria=43,Latvia=371,Netherlands=31,Sweden=46,Republic Of Korea=82,Qatar=974,China=86,Ireland=353,Luxembourg=352,Brazil=55,Poland=48,Slovakia=421,Slovenia=386,France=33,Bulgaria=359,Lithuania=370,Croatia=385,USA=1,Argentina=54,Romania=40,Hungary=36,Japan=81,United Kingdom=44,United Arab Emirates=971,India=91,Spain=34,Canada=1,Czech Republic=420,Turkey=90,Belgium=32,Finland=358,Denmark=45,Italy=39,Mexico=52,South Africa=27,Australia=61,Germany=49,Indonesia=62,Estonia=372",
  "email_validation_regex": "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*(\\+[_A-Za-z0-9-]+){0,1}@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$",
}
const Authorization = {
  PROD: 'Basic bGluay1iYXNlZC1mbG93LWZlLW9hdXRoOlBleUFYS2N6T29SaktXcWpoc3g2aUNZd2RRWDdhTVpp',
  STAG: 'Basic bGluay1iYXNlZC1mbG93LWZlLXN0YWc6Uk1nSXhobm1rQnJLd3pjdXFYQVR3Y0lGRktKZnJaS0M='
}
export function getAuthorization() {
  const host = document && document.location && document.location.host;
  switch (host) {
    case "accounts.paytm.com":
      return Authorization.PROD;
    case "accounts-staging.paytm.in":
      return Authorization.STAG;
    default:
      return Authorization.STAG
  }
}